module.exports = __webpack_public_path__ + "static/img/festivals.e115ba83.png";